export default {"src":"/_next/static/media/personal-loans.7e560428.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};